export default __webpack_public_path__ + "Mobil.5f10d3778e8eee4c98b4.svg";